import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import '../JefeDashboard/JefeDashboard.css'
import { fetchAuth } from '../../utils/api'
import { FaProjectDiagram, FaChevronLeft, FaCalendar, FaUsers, FaTasks, FaCheckCircle, FaClock, FaBan, FaChartPie, FaTag, FaListOl } from 'react-icons/fa'

export default function ColaboradorProyectoDetalle() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [detalle, setDetalle] = useState(null)

  const toUIEstado = (estado) => {
    switch (estado) {
      case 'PENDIENTE': return 'Pendiente'
      case 'ACTIVO': return 'En Progreso'
      case 'RECHAZADO': return 'Cancelado'
      default: return estado || 'Pendiente'
    }
  }

  const formatDate = (s) => {
    const a = String(s || '')
    const part = a.split('T')[0].split(' ')[0]
    if (!part) return '-'
    const [y, m, d] = part.split('-')
    return `${d}/${m}/${y}`
  }

  const toDate = (s) => {
    const a = String(s || '')
    const part = a.split('T')[0].split(' ')[0]
    if (!part) return null
    return new Date(part + 'T00:00:00')
  }

  const daysBetween = (a, b) => {
    if (!a || !b) return null
    const ms = b.getTime() - a.getTime()
    return Math.floor(ms / 86400000)
  }

  const renderColab = (c) => {
    if (!c) return 'Sin asignar'
    if (typeof c === 'string') return c
    if (typeof c === 'object') return c.nombre || c.email || 'Colaborador'
    return 'Sin asignar'
  }

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true)
        setError(null)
        const d = await fetchAuth(`/api/colaborador/proyectos/${id}/detalle/`)
        setDetalle(d)
      } catch (e) {
        setError(e.message || 'Error al cargar detalle')
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [id])

  if (loading) return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 rounded-full bg-indigo-100 flex items-center justify-center mx-auto mb-4">
          <FaProjectDiagram className="text-indigo-500 text-2xl" />
        </div>
        <p className="text-slate-700 text-lg font-medium">Cargando detalle del proyecto...</p>
      </div>
    </div>
  )
  if (error) return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
      <div className="bg-red-50 border border-red-200 rounded-2xl p-8 max-w-md text-center">
        <div className="text-red-600 text-5xl mb-4">⚠️</div>
        <h3 className="text-red-800 text-xl font-bold mb-2">Error al cargar</h3>
        <p className="text-red-600">{error}</p>
      </div>
    </div>
  )

  const estadoUI = toUIEstado(detalle?.estado)

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-slate-100">
      <div className="max-w-7xl mx-auto p-6">
        <div className="mb-4">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-slate-100 text-slate-700 font-semibold hover:bg-slate-200 transition-colors"
          >
            <FaChevronLeft /> Volver
          </button>
        </div>

        <div className="bg-gradient-to-r from-indigo-500 to-indigo-600 rounded-3xl shadow-xl p-6 text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 w-48 h-48 bg-white/10 rounded-full -mr-24 -mt-24" />
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-4">
              <div className="bg-white/20 backdrop-blur-sm p-3 rounded-2xl shadow">
                <FaProjectDiagram className="text-white text-2xl" />
              </div>
              <div>
                <h1 className="text-3xl lg:text-4xl font-bold tracking-tight">{detalle?.nombre_proyecto || 'Proyecto'}</h1>
                <p className="text-white/80 mt-1 max-w-3xl line-clamp-2">{detalle?.descripcion || 'Sin descripción'}</p>
              </div>
            </div>
            <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full font-semibold text-sm">{estadoUI}</div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <div className="bg-white rounded-2xl shadow-lg p-6 border border-slate-200">
            <div className="flex items-center gap-3 mb-3">
              <FaCalendar className="text-slate-400" />
              <h3 className="text-slate-800 font-bold">Fechas</h3>
            </div>
            <div className="space-y-2 text-slate-700">
              {detalle?.fecha_inicio && (
                <p><span className="font-semibold">Fecha de inicio planificada:</span> {formatDate(detalle.fecha_inicio)}</p>
              )}
              {detalle?.fecha_inicio_real && (
                <p><span className="font-semibold">Fecha de inicio real:</span> {formatDate(detalle.fecha_inicio_real)}</p>
              )}
              {detalle?.fecha_fin && (
                <p><span className="font-semibold">Fecha de término planificado:</span> {formatDate(detalle.fecha_fin)}</p>
              )}
              {detalle?.fecha_fin_real && (
                <p><span className="font-semibold">Fecha de término real:</span> {formatDate(detalle.fecha_fin_real)}</p>
              )}
              {detalle?.fecha_inicio_real && detalle?.fecha_fin && (() => {
                const start = toDate(detalle.fecha_inicio_real)
                const end = toDate(detalle.fecha_fin)
                if (!start || !end || end <= start) return null
                const last = toDate(detalle.fecha_fin_real || detalle.fecha_ultima_tarea_completada)
                const total = Math.max(1, daysBetween(start, end))
                const elapsedRaw = daysBetween(start, last || start)
                const elapsed = Math.min(Math.max(0, elapsedRaw ?? 0), total)
                const percent = Math.round((elapsed / total) * 100)
                const r = 48
                const c = 2 * Math.PI * r
                const dash = (c * percent) / 100
                const rem = c - dash
                return (
                  <div className="mt-3 bg-slate-50 rounded-xl p-3 border border-slate-200">
                    <div className="flex items-center gap-2 mb-2 text-slate-700 text-sm font-semibold"><FaChartPie className="text-slate-500" /> Avance real vs fin planificado</div>
                    <div className="flex items-center gap-4">
                      <svg width="120" height="120" viewBox="0 0 120 120" className="shrink-0">
                        <g transform="translate(60,60) rotate(-90)">
                          <circle r={r} cx="0" cy="0" fill="none" stroke="#e2e8f0" strokeWidth="16" />
                          <circle r={r} cx="0" cy="0" fill="none" stroke="#6366f1" strokeWidth="16" strokeDasharray={`${dash} ${rem}`} strokeLinecap="round" />
                        </g>
                      </svg>
                      <div className="flex-1">
                        <div className="text-slate-800 text-2xl font-bold">{percent}%</div>
                        <div className="mt-1 text-xs text-slate-600">{elapsed} días de {total} días</div>
                        <div className="mt-2 flex items-center gap-2">
                          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-indigo-100 text-indigo-700 border border-indigo-200">Avance real</span>
                          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 border">Restante planificado</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })()}
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-6 border border-slate-200">
            <div className="flex items-center gap-3 mb-3">
              <FaUsers className="text-slate-400" />
              <h3 className="text-slate-800 font-bold">Colaboradores</h3>
            </div>
            {detalle?.colaboradores?.length ? (
              <ul className="divide-y divide-slate-200">
                {detalle.colaboradores.map(c => (
                  <li key={c.id_usuario} className="py-2 flex items-center justify-between">
                    <span className="font-medium text-slate-800">{c.nombre}</span>
                    <div className="flex items-center gap-3">
                      <span className="text-slate-500 text-sm">{c.email}</span>
                      {(() => {
                        const desc = String(detalle?.descripcion || '')
                        const accepted = new RegExp(`\\[INVITACION_USUARIO:${String(c.id_usuario)}:ACEPTADA\\]`).test(desc)
                        const isRejected = new RegExp(`\\[INVITACION_USUARIO:${String(c.id_usuario)}:RECHAZADA\\]`).test(desc)
                        const label = accepted ? 'Aceptado' : (isRejected ? 'Rechazado' : (String(c.estado || '').toUpperCase() === 'INACTIVO' ? 'Rechazado' : (String(c.estado || '').toUpperCase() === 'ACTIVO' ? 'Aceptado' : 'Pendiente')))
                        const cls = accepted ? 'bg-green-100 text-green-700' : (isRejected ? 'bg-blue-100 text-blue-700' : (String(c.estado || '').toUpperCase() === 'ACTIVO' ? 'bg-green-100 text-green-700' : (String(c.estado || '').toUpperCase() === 'INACTIVO' ? 'bg-blue-100 text-blue-700' : 'bg-orange-100 text-orange-700')))
                        return (
                          <span className={`px-3 py-1 rounded-full text-xs font-semibold ${cls}`}>{label}</span>
                        )
                      })()}
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-slate-600">Sin colaboradores</p>
            )}
          </div>
        </div>

        {detalle?.metricas && (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mt-6">
            <div className="bg-white rounded-2xl shadow p-4 border border-slate-200">
              <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold"><FaTasks /> Total Tareas</div>
              <div className="text-2xl font-bold text-slate-800 mt-1">{detalle.metricas.tareas_totales}</div>
            </div>
            <div className="bg-white rounded-2xl shadow p-4 border border-slate-200">
              <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold"><FaClock /> En Revisión</div>
              <div className="text-2xl font-bold text-slate-800 mt-1">{detalle.metricas.tareas_en_revision}</div>
            </div>
            <div className="bg-white rounded-2xl shadow p-4 border border-slate-200">
              <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold"><FaCheckCircle /> Completadas</div>
              <div className="text-2xl font-bold text-slate-800 mt-1">{detalle.metricas.tareas_completadas}</div>
            </div>
            <div className="bg-white rounded-2xl shadow p-4 border border-slate-200">
              <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold"><FaTasks /> Pendientes</div>
              <div className="text-2xl font-bold text-slate-800 mt-1">{detalle.metricas.tareas_pendientes}</div>
            </div>
            <div className="bg-white rounded-2xl shadow p-4 border border-slate-200">
              <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold"><FaBan /> Canceladas</div>
              <div className="text-2xl font-bold text-slate-800 mt-1">{detalle.metricas.tareas_canceladas}</div>
            </div>
            <div className="bg-white rounded-2xl shadow p-4 border border-slate-200">
              <div className="flex items-center gap-2 text-slate-600 text-xs font-semibold"><FaUsers /> Colaboradores</div>
              <div className="text-2xl font-bold text-slate-800 mt-1">{detalle.metricas.colaboradores_count}</div>
            </div>
          </div>
        )}

        <div className="mt-8">
          <div className="bg-gradient-to-b from-white to-slate-50 rounded-2xl shadow-xl p-6 border border-slate-200">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-slate-800 font-bold">Distribución de Proyecto</h3>
            </div>
            {detalle?.etapas?.length ? (
              <ul className="space-y-3">
                {detalle.etapas.map(e => (
                  <li key={e.id_etapa} className={`bg-white rounded-xl p-4 border border-slate-200 shadow-sm`}>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <p className="font-semibold text-slate-800">{e.nombre}</p>
                      </div>
                      <div className="flex items-center gap-2">
                        {String(detalle?.current_etapa_id) === String(e.id_etapa) && (
                          <span className="px-2 py-1 rounded-full text-xs font-semibold bg-indigo-100 text-indigo-700 border">Actual</span>
                        )}
                        {String(e.estado || '').toLowerCase() === 'activa' && (
                          <span className="px-3 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-700">Activa</span>
                        )}
                        {String(e.estado || '').toLowerCase() === 'completada' && (
                          <span className="px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700">Completada</span>
                        )}
                      </div>
                    </div>
                    <div className="mt-2 flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium bg-slate-100 text-slate-700 border">
                          <FaTag className="text-[10px]" />
                          <span>Slug: {e.slug}</span>
                        </span>
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium bg-slate-100 text-slate-700 border">
                          <FaListOl className="text-[10px]" />
                          <span>Orden: {e.orden}</span>
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-slate-100 text-slate-700 border">
                          <FaTasks className="text-[10px]" />
                          <span>Tareas: {e.tareas?.total || 0}</span>
                        </span>
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-slate-100 text-slate-700 border">
                          <FaClock className="text-[10px]" />
                          <span>Pendientes: {e.tareas?.pendientes || 0}</span>
                        </span>
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-slate-100 text-slate-700 border">
                          <FaChartPie className="text-[10px]" />
                          <span>Progreso: {e.tareas?.en_progreso || 0}</span>
                        </span>
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-slate-100 text-slate-700 border">
                          <FaCheckCircle className="text-[10px]" />
                          <span>Completadas: {e.tareas?.completadas || 0}</span>
                        </span>
                      </div>
                    </div>
                    {Array.isArray(e.items) && e.items.length > 0 && (
                      <div className="mt-3 w-full">
                        <ul className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-200">
                          {e.items.map((t) => (
                            <li key={t.id_tarea} className="px-3 py-3">
                              <div className="flex items-center justify-between">
                                <div className="font-medium text-slate-800 truncate">{t.nombre || 'Tarea'}</div>
                                <div className="flex items-center gap-2">
                                  {t.prioridad && (
                                    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold border ${
                                      t.prioridad === 'Alta' ? 'bg-red-100 text-red-700 border-red-200' :
                                      t.prioridad === 'Media' ? 'bg-yellow-100 text-yellow-700 border-yellow-200' :
                                      'bg-green-100 text-green-700 border-green-200'
                                    }`}>{t.prioridad}</span>
                                  )}
                                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold bg-slate-100 text-slate-700`}>{t.estado || 'Pendiente'}</span>
                                </div>
                              </div>
                              <div className="mt-1 text-xs text-slate-600 flex items-center justify-between">
                                <span>{renderColab(t.colaborador)}</span>
                                <div className="flex items-center gap-2">
                                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 border">
                                    <FaCalendar className="text-[10px]" />
                                    <span>Inicio: {t.fecha_inicio ? formatDate(t.fecha_inicio) : '-'}</span>
                                  </span>
                                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 border">
                                    <FaClock className="text-[10px]" />
                                    <span>Entrega: {t.fecha_entrega_inicial ? formatDate(t.fecha_entrega_inicial) : (t.fecha_termino ? formatDate(t.fecha_termino) : '-')}</span>
                                  </span>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-slate-600">Sin etapas creadas</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}